/**
 * getApiHost/getSyncHost read process.env fresh on every call (rather than
 * caching at module load) so tests can still reassign REACT_APP_* env vars
 * per-test the way they already do.
 */
export function resolveHost(envValue?: string): string {
	if (!envValue) {
		return '';
	}

	const currentHost = window.location.hostname;
	if (currentHost.includes('localhost')) {
		return envValue;
	}

	const currentHostParts = currentHost.split('.');
	if (currentHostParts.length < 2) {
		return envValue;
	}

	const normalizedEnvValue = /^https?:\/\//.test(envValue) ? envValue : `https://${envValue}`;

	let parsed: URL;
	try {
		parsed = new URL(normalizedEnvValue);
	} catch {
		return envValue;
	}

	const label = parsed.hostname.split('.')[0];
	const rootDomain = currentHostParts.slice(-2).join('.');

	return `${parsed.protocol}//${label}.${rootDomain}`;
}

// Confirmed to share the same backend across every brandlive-*/brandtv-* zone.
// REACT_APP_SOCKET_HOST is NOT included here: greenroom-socket has no DNS
export const getApiHost = (): string => resolveHost(process.env.REACT_APP_API_HOST);
export const getSyncHost = (): string => resolveHost(process.env.REACT_APP_SYNC_HOST);
